import { v4 as generateID } from '@lukeed/uuid';
const { parse, stringify } = JSON;
export function addMissingIDs(peaks, options = {}) {
    const { output = parse(stringify(peaks)) } = options;
    for (const peak of output) {
        if (!('id' in peak)) {
            peak.id = generateID();
        }
    }
    return output;
}
//# sourceMappingURL=addMissingIDs.js.map